import type { IOption, ISpecification } from '@ztechapps/common.contract'
import { jsonTryParse } from '@ztechapps/common.utils'
import get from 'lodash/get'
import { useProductSpecificationValue } from '../useProductSpecificationValue'

export const useProductSpecification = <T>(name: string): T => {
  //look for the appSetting with the key of PRODUCT_SPECIFICATIONS
  const { value: stringValue } = useProductSpecificationValue({ appSettingKey: 'PRODUCT_SPECIFICATIONS' })

  //parse it to hte actual object
  const parsedValue = jsonTryParse(stringValue) as Record<any, any>

  const specValue = get(parsedValue, name)

  return specValue
}

const useProductSpecificationOptions = (name: string): IOption[] => {
  const spec = useProductSpecification<ISpecification>(name)
  const result = spec?.inputProps?.options
  return result
}

export const useDieSetTypes = (): IOption[] => {
  return useProductSpecificationOptions('dieSetType')
}
export const useDieShapes = (): IOption[] => {
  return useProductSpecificationOptions('shape')
}
export const useProductCategories = (): IOption[] => {
  return useProductSpecificationOptions('category')
}
